/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Saturation_LabelInputs */

const en_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturation`)
};

const fr_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturation`)
};

const de_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sättigung`)
};

const it_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturazione`)
};

const ru_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Насыщенность`)
};

const es_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturación`)
};

const zh_cn2_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`饱和`)
};

const ja_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`飽和`)
};

const hi_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिपूर्णता`)
};

const pt_pt2_video_filters_saturation_label = /** @type {(inputs: Video_Filters_Saturation_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturação`)
};

/**
* | output |
* | --- |
* | "Saturation" |
*
* @param {Video_Filters_Saturation_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_saturation_label = /** @type {((inputs?: Video_Filters_Saturation_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Saturation_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_filters_saturation_label(inputs)
	if (locale === "de") return de_video_filters_saturation_label(inputs)
	if (locale === "it") return it_video_filters_saturation_label(inputs)
	if (locale === "ru") return ru_video_filters_saturation_label(inputs)
	if (locale === "es") return es_video_filters_saturation_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_filters_saturation_label(inputs)
	if (locale === "ja") return ja_video_filters_saturation_label(inputs)
	if (locale === "hi") return hi_video_filters_saturation_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_filters_saturation_label(inputs)
	return en_video_filters_saturation_label(inputs)
});